export default __webpack_public_path__ + "assets/images/6821817259b89275b51050170dc64d75.png";